export default __webpack_public_path__ + "static/jameelMotorsLogoBlueOld-c1230052e1ca5d2b85509960d85d4471.svg";